{
    "validation": {
        "field": {
            "date": {
                "min": "${label} får inte infalla före ${minDate}.",
                "max": "${label} får inte infalla efter ${maxDate}."
            },
            "email": {
                "text": "Kontrollera e-postadressens format."
            },
            "length": {
                "between": "${label} måste vara mellan ${min} och ${max} tecken.",
                "exactly": "${label} måste vara exakt ${exactly} tecken.",
                "max": "${label} får inte vara längre än ${max} tecken.",
                "min": "${label} får inte vara kortare än ${min} tecken."
            },
            "password": {
                "exclude": "Får inte innehålla något av följande tecken: ${blacklist}",
                "lowerCase": "Måste innehålla minst en liten bokstav.",
                "number": "Måste innehålla minst en siffra.",
                "specialChar": "Måste innehålla minst ett specialtecken.",
                "upperCase": "Måste innehålla minst en stor bokstav."
            },
            "required": {
                "text": "${label} krävs."
            },
            "ssn": {
                "text": "Använd formatet ÅÅÅÅMMDD-XXXX.",
                "textDash": "Använd formatet ÅÅÅÅMMDDXXXX.",
                "textMinAge": "Du måste vara minst ${minAge} år eller äldre.",
                "textMaxAge": "Du får inte vara äldre än ${maxAge} år."
            },
            "value": {
                "text": "\"${value}\" måste vara samma som \"${compareValue}\".",
                "textInverted": "\"${value}\" får inte vara samma som \"${compareValue}\"."
            }
        },
        "form": {
            "dateDiff": {
                "max": "Skillnaden mellan ${fieldALabel} och ${fieldBLabel} får inte vara mer än ${maxDiff} ${maxUnitLabel}.",
                "min": "Skillnaden mellan ${fieldALabel} och ${fieldBLabel} måste vara mer än ${minDiff} ${minUnitLabel}",
                "units": {
                    "seconds": {
                        "singular": "sekund",
                        "plural": "sekunder"
                    },
                    "minutes": {
                        "singular": "minut",
                        "plural": "minuter"
                    },
                    "hours": {
                        "singular": "timme",
                        "plural": "timmar"
                    },
                    "days": {
                        "singular": "dag",
                        "plural": "dagar"
                    },
                    "weeks": {
                        "singular": "vecka",
                        "plural": "veckor"
                    },
                    "years": {
                        "singular": "år",
                        "plural": "år"
                    }
                }
            },
            "dateOrder": {
                "text": "Följande måste anges i kronologisk tidsföljd: ${fieldLabels}."
            },
            "dateRange": {
                "min": "${label} får inte infalla före ${minLabel}.",
                "max": "${label} får inte infalla efter ${maxLabel}."
            },
            "sameValue": {
                "textA": "${fieldALabel} och ${fieldBLabel} måste vara samma.",
                "textB": "${fieldBLabel} och ${fieldALabel} måste vara samma."
            }
        }
    }
}
